import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { Subject } from 'rxjs';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-form-done',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule
  ],
  providers: [CurrencyPipe],
  templateUrl: './form-done.component.html',
  styleUrl: './form-done.component.css'
})
export class FormDoneComponent implements OnInit, OnDestroy {
  iosLinke = '';
  androidLinke = '';
  ios: any = {
    akps: 'https://apps.apple.com/us/app/akpain-spine/id6471281069',
    MyPainSolution: 'https://apps.apple.com/us/app/mypainsolution/id6474763802',
  }
  android: any = {
    akps: 'https://play.google.com/store/apps/details?id=com.akps.akpsapp',
    MyPainSolution: 'https://play.google.com/store/apps/details?id=com.mypainsolution.mypainsolutionapp',
  }
  private destroySubject = new Subject<void>();

  consentsFormsIncomplete: boolean = false;
  doneIcon: string | { outer: string; inner: string; } = 'healent-ios-checkmark-circle';
  doneTitle: string = 'Done!';
  doneBody: string = 'Your form has been successfully submitted! Fantastic work—you\'re all set. Feel free to close this tab now. Thanks for your time!';
  blinkIcon: boolean = false;
  isReactNative: boolean = false;
  isWebLogin: boolean = false;
  displayRemainingBalance: string = '';
  payAtFrontDeskOption: boolean = false;
  remainingBalance: number = 0;

  get isDoneIconString(): boolean {
    return typeof this.doneIcon === 'string';
  }

  get doneIconObject(): { outer: string; inner: string; } | null {
    if (typeof this.doneIcon === 'object' && this.doneIcon !== null && 'outer' in this.doneIcon && 'inner' in this.doneIcon) {
      return this.doneIcon as { outer: string; inner: string; };
    }
    return null;
  }

  constructor(private route: ActivatedRoute, private currencyPipe: CurrencyPipe) { }

  ngOnInit(): void {
    const isWebview = localStorage.getItem('is_react_native_webview') === 'true';
    this.isReactNative = isWebview;

    this.route.queryParams.subscribe((params) => {
      this.isWebLogin = params['weblogin'] === 'true' || params['weblogin'] === true; // Handle string or boolean
      this.consentsFormsIncomplete = params['consents_forms_incomplete'] === 'true';
      this.payAtFrontDeskOption = params['payAtFrontDesk'] === 'true';
      if (this.consentsFormsIncomplete) {
        this.doneIcon = 'healent-warning';
        this.blinkIcon = true;
        this.doneTitle = 'Consents Declined';
        this.doneBody = 'The required consent forms have not been completed. To proceed with your appointment and see your physician, these forms must be signed.\n\u{1F449} Please report to the front desk so we can assist you in completing them as soon as possible.\n\nThank you for your attention — we’re here to help.';
      } else if (this.payAtFrontDeskOption) {
        const balance = parseFloat(params['remainingBalance'] || '0');
        if (balance <= 0) {
          this.remainingBalance = 0;
        } else {
          this.doneIcon = { outer: 'healent-ellipse-1314', inner: 'healent-i' };
          this.blinkIcon = false;
          this.doneTitle = 'Pay at front-desk';
          this.doneBody = 'You\'re almost done! Please complete your payment at the front desk';
          this.remainingBalance = balance;
        }
      } else {
        this.remainingBalance = parseFloat(params['remainingBalance'] || '0');
      }
      
      if (this.remainingBalance > 0) {
        this.displayRemainingBalance = this.currencyPipe.transform(this.remainingBalance, 'USD', 'symbol', '1.2-2') || '$0.00';
      }
    });
    const hospital_slug = localStorage.getItem('providerName') || '';
    this.iosLinke = this.ios[hospital_slug] || '';
    this.androidLinke = this.android[hospital_slug] || '';
    const providerName = localStorage.getItem('providerName');

    if (providerName) {
      document.body.classList.add(`provider-${providerName}`);
    }
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
  sendClose(): void {
    if (this.isWebLogin) {
      const domain = environment.API_DOMAIN_LEGACY || 'dev.healent.com';
      window.location.href = `https://${domain}/forms`;
      return;
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ flag: 'Back-home' }));
    }
  }

  sendLogout(): void {
    if (this.isWebLogin) {
      const domain = environment.API_DOMAIN_LEGACY || 'dev.healent.com';
      window.location.href = `https://${domain}/login`;
      return;
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ flag: 'logout' }));
    }
  }

}

